import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { removeDocument } from '../../redux/actions/DocumentAction';
import { useDispatch } from 'react-redux';
import { ListItem, ListItemText, Tooltip, IconButton } from '@mui/material';
import { decrypt } from '../../util/Security';

const DocListItem = ({ props }) => {
    const dispatch = useDispatch();

    const deleteDocument = (docId) => {
        let loggedIn = localStorage.getItem('login');
        if (loggedIn) {
            let data = decrypt(loggedIn);
            const docDetails = {
                candidate_id: data?.candidateId,
                attachment_id: docId,
            };
            dispatch(removeDocument(docDetails));
        }
    };
    return (
        <ListItem
            secondaryAction={
                <Tooltip title={`Delete ${props?.file_name || ''}`}>
                    <IconButton
                        edge='end'
                        aria-label='delete'
                        size='small'
                        onClick={() => deleteDocument(props?.id)}
                    >
                        <DeleteIcon fontSize='inherit' color='error' />
                    </IconButton>
                </Tooltip>
            }
            disablePadding
            disableGutters
        >
            <ListItemText secondary={props?.file_name || 'Corrupted file '} />
        </ListItem>
    );
};

export default DocListItem;
